import { Inject, Injectable } from '@angular/core';
import { IMetricsService } from './metrics-service.interface';
import { IEnvironmentService } from '../../../../core/services/environment/environment.interface';
import { HttpClient } from '@angular/common/http';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MetricsService implements IMetricsService {
  private dataApi: string;
  private metricsRequest$: Observable<any>;
  private settingsRequest$: Observable<any>;

  constructor(@Inject('IEnvironmentService') private envService: IEnvironmentService, private http: HttpClient) {
    this.dataApi = this.envService.getVar('services.api') as string;
  }

  getBaseMetrics(): Observable<{ id: number; name: string }[]> {
    if (!this.metricsRequest$) {
      this.metricsRequest$ = this.http
        .post(`${this.dataApi}/table/data`, {
          table: 'MetricsTable',
          page: 1,
          limit: 1000,
          filters: { metric_type: ['App\\Modules\\Metrics\\MetricTypes\\BaseMetric'] },
          order_values: {},
          scope_values: { archived: [false] },
        })
        .pipe(shareReplay());
    }

    return this.metricsRequest$.pipe(
      map((data: any) => {
        return data.data.rows.map(({ id, name }) => ({ id, name }));
      })
    );
  }

  updateMetrics(): void {
    this.metricsRequest$ = null;
  }

  getMetricsSettings(): Observable<any> {
    if (!this.settingsRequest$) {
      this.settingsRequest$ = this.http.get(`${this.dataApi.split('/api')[0]}/api/metrics/settings`).pipe(shareReplay());
    }

    return this.settingsRequest$;
  }
}
